import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import UserRoles from '../../constants/UserRoles'

// Containers
import Login from './Shared/Login'
import LogoutCallback from './Shared/LogoutCallback'
import SigninCallback from './Shared/SigninCallback'
import SilentRenewCallback from './Shared/SilentRenewCallback'
import PageNotFound from './Shared/PageNotFound'
import Partner from './Partner'
import Admin from './Admin'
import AuthProvider from '../../providers/AuthProvider'

// Main App Router
const AppRouter = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Switch>
          {/* Normal routes */}
          <Route path="/" component={Login} exact={true} />
          <Route path="/logout-callback" component={LogoutCallback} exact={true} />
          <Route path="/signin-callback" component={SigninCallback} exact={true} />
          <Route path="/silent-renew-callback" component={SilentRenewCallback} exact={true} />
          {/* Private routes */}
          <PrivateRoute path="/partner" component={Partner} />
          <PrivateRoute path="/admin" component={Admin} role={UserRoles.SYSTEM_ADMIN} />
          {/* Fallback route */}
          <Route component={PageNotFound} />
        </Switch>
      </AuthProvider>
    </BrowserRouter>
  )
}

// Private Route
const PrivateRoute = ({ component: Component, role = null, ...rest }) => {
  const session = useSelector(({ auth }) => auth.session)
  const isAuthenticated = !!session

  // Check if user is authenticated
  if (!isAuthenticated) {
    return (
      <Route
        {...rest}
        render={() => <Redirect to="/" />}
      />
    )
  }
  // Check if user is has access to route based on role
  const hasAccess = !role || session?.profile?.role?.includes(role)
  return (
    <Route
      {...rest}
      render={(props) => hasAccess ? <Component {...props} /> : <Redirect to="/" />}
    />
  )
}

export default AppRouter